export const Types = {
  UPDATE_ADMIN_REVIEW: "UPDATE_ADMIN_REVIEW"
};

export const updateAdminReview = (contactId, adminReview, reason) => ({
  type: Types.UPDATE_ADMIN_REVIEW,
  payload: { contactId, adminReview, reason }
});
